/**
 * AccentBar — Brand accent strip (rare-blue → epic-purple → legendary-orange).
 *
 * Designed to mount as the first element of every app's root layout so the
 * EngageXP brand gradient appears above any navigation chrome. The 4 apps that
 * already render GlobalHeader get the same strip embedded; every other app
 * uses this standalone component.
 *
 * Decorative only — rendered with role="presentation" + aria-hidden so it
 * never interferes with assistive technology.
 *
 * @package @engagexp/legendary-ui-primitives
 */

import { cn } from '../../../utils/cn';
import styles from './accent-bar.module.css';

export interface AccentBarProps {
  /** Extra classes merged onto the bar root. */
  className?: string;
  /** Strip height in px. Default: 4. */
  height?: number;
  /** Stick to the top of the viewport above app-level sticky chrome. Default: true. */
  sticky?: boolean;
}

export function AccentBar({
  className,
  height = 4,
  sticky = true,
}: AccentBarProps) {
  return (
    <div
      role="presentation"
      aria-hidden="true"
      className={cn(styles.root, sticky && styles.sticky, className)}
      style={{ height: `${String(height)}px` }}
    />
  );
}

AccentBar.displayName = 'AccentBar';
